import React, { ChangeEvent, useState } from 'react'

import dayjs, { Dayjs } from 'dayjs'
import toast from 'react-hot-toast'

import PersonalInformationSection from './BasicSection/PersonalInformationSection'
import {
  Button,
  CredentialsSection,
  ProfessorsSection,
  StudentsSection,
} from '..'
import { useUser } from '../../context'
import { Profesor, Student } from '../../types'
import { Spacer } from '../global'

import { ProfileContainer } from './styles'

const Profile = ({
  type,
  editedProfile,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setEditedProfile,
}: {
  type: string | null
  editedProfile: Student | Profesor | null
  setEditedProfile: (person: Student | Profesor) => void
}) => {
  const { user, onEditionMode, setOnEditionMode, updateUser } = useUser()
  const [showCredentials, setShowCredentials] = useState(false)
  const [editedData, setEditedData] = useState<Student | Profesor | null>(
    editedProfile,
  )

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    editedData &&
      setEditedData({
        ...editedData,
        [e.target.name]: e.target.value,
      })
  }

  const handleDateChange = (date: Dayjs | null) => {
    editedData &&
      setEditedData({
        ...editedData,
        birthDate: dayjs(date).format('YYYY-MM-DD'),
      })
  }

  const handleMenuChange = (
    filterName: string,
    value: string | string[] | null,
  ) => {
    editedData &&
      setEditedData({
        ...editedData,
        [filterName]: value,
      })
  }

  const handleChangeEmail = (value: string) => {
    editedData &&
      setEditedData({
        ...editedData,
        email: value,
      })
  }

  const handleSave = async () => {
    if (editedData) {
      try {
        await updateUser(editedData)
        setOnEditionMode(false)

        toast.success('Se han guardado los cambios')
      } catch (error) {
        console.log(error)
        toast.error('Se ha producido un error')
      }
    }
  }

  const handleCancel = () => {
    setEditedData(editedProfile)
    setOnEditionMode(false)
  }

  return (
    editedData && (
      <ProfileContainer>
        <PersonalInformationSection
          type={type}
          editedProfile={editedData}
          handleChange={handleChange}
          handleDateChange={handleDateChange}
          handleMenuChange={handleMenuChange}
        />
        {editedData.role === 'student' && (
          <StudentsSection
            type={type}
            editedProfile={editedData as Student | null}
            handleMenuChange={handleMenuChange}
            handleChange={handleChange}
          />
        )}
        {editedData.role !== 'student' && (
          <ProfessorsSection
            type={type}
            editedProfile={editedData}
            handleMenuChange={handleMenuChange}
            handleChange={handleChange}
          />
        )}
        <Spacer height={40} />
        {editedData.uid === user?.uid && onEditionMode && (
          <CredentialsSection
            type={type}
            editedProfile={editedData}
            handleChangeEmail={handleChangeEmail}
            showCredentials={showCredentials}
            setShowCredentials={setShowCredentials}
          />
        )}
        {!showCredentials && onEditionMode && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              // alignItems: 'center',
              gap: 20,
            }}
          >
            {/* <Spacer height={20} /> className="d-flex flex-column align-items-center" */}
            {editedData.uid === user?.uid && (
              <Button
                className="light-blue"
                onClick={() => setShowCredentials(!showCredentials)}
                label="Cambiar credenciales de acceso"
                fontSize={16}
              />
            )}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 20,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Button
                className="light-grey"
                onClick={handleCancel}
                label="Cancelar"
                fontSize={14}
              />
              <Button
                className="dark-grey"
                onClick={handleSave}
                label="Guardar Datos"
                fontSize={14}
              />
            </div>
          </div>
        )}
      </ProfileContainer>
    )
  )
}

export default Profile
